import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

function ProtectedRoute({ children }) {
  const bereich = Cookies.get('Bereich');
  const zbPass = Cookies.get('zbpasswordentered') === 'true';
  const pPass = Cookies.get('ppasswordentered') === 'true';

  const hasAccess =
    bereich &&
    ((bereich === 'Zeltbetreuung' && zbPass) ||
      (bereich === 'Parlament' && pPass) ||
      (bereich !== 'Zeltbetreuung' && bereich !== 'Parlament'));

  return hasAccess ? children : <Navigate to="/home" replace />;
}

export default ProtectedRoute;
